<template>
    <div :class="namespaceClass()">
        <mds-checkbox :class="namespaceClass('__header')" :checked="checked" :disabled="disabled" @change="handleReportChecked">{{ text }}</mds-checkbox>
        <slot></slot>
    </div>
</template>

<script>
import HypoVueBaseMixin from "hypo-vue-base-mixin";
import MdsCheckbox from "@mds/checkbox";
export default {
    name: "report-list-item",
    props: {
        text: {
            type: String,
            default: ""
        },
        checked: Boolean,
        disabled: Boolean
    },
    components: {
        MdsCheckbox
    },
    mixins: [HypoVueBaseMixin],
    methods: {
        handleReportChecked(e) {
            this.$emit("report-status-change", e);
        }
    }
};
</script>

<style lang="scss" scoped>
@import "~@mds/typography";
.report-list-item {
    border: 1px solid #e5e5e5;
    border-radius: 6px;
    &__header {
        padding: 16px;
    }
    ::v-deep .mds-checkbox___hypo .mds-checkbox__visible-wrap___hypo {
        margin: 0px;
        flex-basis: 100%;
        align-items: center;
        .mds-checkbox__visual___hypo {
            width: 23px;
            height: 23px;
            margin-right: 10px;
            .mds-icon {
                width: 21px;
                height: 21px;
                margin-top: -10.5px;
                margin-left: -10.5px;
            }
        }
        .mds-checkbox__text___hypo {
            @include mds-body-text-l($bold: true);
            color: $mds-color-neutral-12;
            height: 27px;
        }
    }
}
</style>
